<template>
    <div class="tab-panel padded">
        <div class="d-flex">
            <button class="btn light wide ml-auto mb-3">
                <i class="ico-add color-1"></i>
                New invoice
            </button>
        </div>

        <list :header="header" :body="body" :rows="getInvoices"></list>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import List from '@/tools/list/baseList'

    export default {
        data: function() {
            return {
                header: {
                    list: null
                },
                body: {
                    customCells: null,
                },
            }
        },
        created: function() {
            var vm = this;
            
            this.header.list = {
                date: 'Date',
                description: 'Description',
                type: 'Type',
                value: 'Amount',
                status: 'Status'
            };

            this.body.customCells = {
                date: function(invoice) {                   
                    return vm.bold(vm.formatDate(invoice.date));
                },
                description: function(invoice) {
                    return vm.bold(invoice.description);
                },
                type: function(invoice) {
                    return vm.bold(invoice.type);
                },
                value: function(invoice) {
                    return vm.bold(invoice.value);
                },
                status: function(invoice) {
                    return vm.status(invoice.status);
                },
            }
        },
        computed: {
            ...mapGetters([
                'reservation',
                'getInvoices',
            ]),
        },
        methods: {
            bold: function(field) { 
                return '<strong>' + field + '</strong>';
            },
            status: function(status) {
                let type = (status === 'paid') ? 'success' : 'indue';

                return '<div class="status-meter ' + type + '">' + status.charAt(0).toUpperCase() + status.slice(1) + '</div>';
            },
        },
        components: {
            List,
        }
    }
</script>


// WEBPACK FOOTER //
// ViewInvoices.vue?8586d9ec